import userGroupNames from '../../consts/auth/userGroupNames';
import connectionTypes from '../../consts/connectionTypes';
import {IAP_FEATURES_CODES} from '../../consts/iap/iapFeatureCodes';

// Unlisted features stay open to every group. Value = the connection types gated, `null` = all.
export default {
    [userGroupNames.LAS]: {[IAP_FEATURES_CODES.SWITCH_MASTER_BADGE]: null},
    [userGroupNames.CELLULAR]: {[IAP_FEATURES_CODES.SETUP]: [connectionTypes.CELLULAR]},
    [userGroupNames.WI_FI]: {[IAP_FEATURES_CODES.SETUP]: [connectionTypes.WIFI]},
};
